import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'
import { createStore, Provider } from 'jotai'
import { match } from 'ts-pattern'

import RecapFarmerInstitiutionsPage from '@/components/pages/guest/_recap-farmer/containers/recap-farmer-institutions'
import { useFilters } from '@/components/pages/guest/_recap-farmer/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_recap-farmer/types'

const store = createStore()

export const Route = createFileRoute('/_guest/guest/recap-farmer-institutions')({
  component: () => (
    <Provider store={store}>
      <RouteComponent />
    </Provider>
  ),
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = useFilters()

  useEffect(() => {
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    if (search.district_code) {
      filters.onDistrictChange(search.district_code, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.province_code, search.city_code, search.district_code])

  return (
    <RecapFarmerInstitiutionsPage
      activeTab={search.tab}
      onTabChange={tab => {
        const onChange = match(tab)
          .with('national', () => filters.reset)
          .with('province', () => filters.onProvinceChange)
          .with('city', () => filters.onCityChange)
          .with('district', () => filters.onDistrictChange)
          .otherwise(() => filters.reset)

        const code = match(tab)
          .with('province', () => search.province_code ?? '')
          .with('city', () => search.city_code ?? '')
          .with('district', () => search.district_code ?? '')
          .otherwise(() => '')

        onChange(code)
        navigate({ search: { ...search, tab } })
      }}
    />
  )
}
